import { PropTypes } from "prop-types";

import { fieldHeaderCss } from "./AssignmentFieldHeader.style";

const propTypes = {
  children: PropTypes.string,
};

const AssignmentFieldHeader = ({ children }) => {
  return <h3 css={fieldHeaderCss}>{children}</h3>;
};

AssignmentFieldHeader.propTypes = propTypes;

export default AssignmentFieldHeader;
